import { helpers, required } from "@vuelidate/validators";

export class ExamModel {
    constructor() {
        this.entityId = null;
        this.examType = null;
        this.examProducts = [];
        this.virtualExamDate = null;
        this.fileReviewPeriodStartDate = null;
        this.fileReviewPeriodEndDate = null;
        this.phase = null;
        this.informationalMeetingDate = null;
        this.openingDate = null;
    }

    static getValidationRules() {
        return {
            entityId: {
                required: helpers.withMessage('Entity is required', required)
            },
            examType: {
                required: helpers.withMessage('Exam Type is required', required)
            },
            examProducts: {
                required: helpers.withMessage('At least one Exam Product is required', required),
                minLength: helpers.withMessage('At least one Exam Product is required', (value) => {
                    return !!(value && value.length > 0);
                })
            },
            virtualExamDate: {
                required: helpers.withMessage('Virtual Exam Date is required', required)
            },
            fileReviewPeriodStartDate: {
                required: helpers.withMessage('File Review Period Start Date is required', required)
            },
            fileReviewPeriodEndDate: {
                required: helpers.withMessage('File Review Period End Date is required', required),
                afterStartDate: helpers.withMessage(
                    'End Date must be after Start Date',
                    function(value) {
                        if (!value || !this.fileReviewPeriodStartDate) {
                            return true; // Let required validator handle empty values
                        }
                        const startDate = new Date(this.fileReviewPeriodStartDate);
                        const endDate = new Date(value);
                        return endDate > startDate;
                    }
                )
            },
            phase: {
                required: helpers.withMessage('Phase is required', required)
            },
            informationalMeetingDate: {
                required: helpers.withMessage('Informational Meeting Date is required', required)
            },
            openingDate: {
                required: helpers.withMessage('Opening Date is required', required)
            }
        };
    }
}

